import { trustedBy } from '../components/trusted-by';

trustedBy();